import { NestedOption } from '~/core/shared/types/utility';

/**
 * The label above each select, named after the choice in the select before it ("Insurance
 * Type"). The first is null because the field's own label, which FormField renders, already
 * names it.
 */
export const getNestedSelectLabels = (
  selects: ReadonlyArray<readonly NestedOption[]>,
  segments: readonly string[],
  fieldLabel: string | undefined,
): Array<string | null> =>
  selects.map((_, index) => {
    const parent =
      index === 0
        ? undefined
        : selects[index - 1].find(
            (option) => option.value === segments[index - 1],
          );

    return parent ? `${parent.label} ${fieldLabel ?? ''}`.trim() : null;
  });
